import { createModel } from '@/store/tools';

const model = {
    namespace: 'insuranceorder',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getInsurePolicyDetailsById': T('getInsurePolicyDetailsById'), // 获取配送订单详情
            'getInsurePolicyList': T('getInsurePolicyList'), // 获取保单订单列表
            'getPayTypeEnum': T('getPayTypeEnum'),
        },
        actions: {
            'getInsurePolicyDetailsById': A('getInsurePolicyDetailsById'), // 获取配送订单详情
            'getCleanDetail': C('getInsurePolicyDetailsById'), // 管理清除详情数据
            'getInsurePolicyList': A('getInsurePolicyList'), // 获取保单订单列表
            'getPayTypeEnum': A('getPayTypeEnum'),
        },
        sagas: {
            'getInsurePolicyDetailsById': S('getInsurePolicyDetailsById', '/?cmd=com.xqxc.api.pig.mis.biz.rider.RiderMisService.getInsurePolicyDetailsById'),
            'getInsurePolicyList': S('getInsurePolicyList', '/?cmd=com.xqxc.api.pig.mis.biz.rider.RiderMisService.getInsurePolicyList'),
            'getPayTypeEnum': S('getPayTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
        },
        reducers: {
            'InsurePolicyDetailsById': R('getInsurePolicyDetailsById', {}),
            'InsurePolicyList': R('getInsurePolicyList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'payTypeEnum': R('getPayTypeEnum', []),
        }
    })
};
export default createModel(model);